// eslint-disable-next-line import/prefer-default-export
export const GET_NO_LOS = 'GET_NO_LOS';
